<template>
    <!--03原高级平台班级对比-->
    <div  class="bg-qgry p-b-40" v-if="list.length>1">
      <!-- 赠品详情弹框 -->
    <div class="send-infoPopup" v-if="zenpingxiangqin">
      <div class="sendPopup-cont">
        <h3 class="sendPopup-h3">赠品详情</h3>
        <div class="sendPopup-banji">
          <span class="sendPopup-banjiHd">当前班级：</span>
          <div class="sendPopup-banjiBd" @mouseout="zenpingxiangqinShowDetal=false">
            <p class="sendPopup-banjiC" @mousemove="zenpingxiangqinShowDetal=true" >{{zenpingClassList[zenpingxiangqinDetailIndex].MyClassName}}</p>
            <ul class="sendPopup-banjiUl" @mousemove="zenpingxiangqinShowDetal=true" v-show="zenpingxiangqinShowDetal">
              <li v-for="(v,i) in zenpingClassList" @click="changeZpClass(i,v.MyClassId)" :key="i">{{v.MyClassName}}</li>
            </ul>
          </div>
        </div>
        <div class="sendPopup-tableBox">
          <table class="sendPopup-table" cellpadding="0" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th width="12.5%">赠品</th>
                <th width="42.5%">详情</th>
                <th width="12.5%">版本</th>
                <th width="32.5%">寄送时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v,i) in bookList.JiaoCai" :key="i">
                <td v-if="i==0" :rowspan="bookList.JiaoCai.length">教材</td>
                <td>{{v.BookName}}</td>
                <td>{{v.ShowYear}}版</td>
                <td>{{v.BookSendTime}}</td>
              </tr>
              <tr v-for="(v,i) in bookList.JiaoFu" :key="i">
                <td  v-if="i==0" :rowspan="bookList.JiaoFu.length">教辅</td>
                <td>{{v.BookName}}</td>
                <td>{{v.ShowYear}}版</td>
                <td>{{v.BookSendTime}}</td>
              </tr>
              <tr v-for="(v,i) in bookList.TiKu" :key="i">
                <td v-if="i==0" :rowspan="bookList.TiKu.length">题库</td>
                <td>{{v.BookName}}</td>
                <td>{{v.ShowYear}}</td>
                <td>{{v.BookSendTime}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <a href="javascript:;" class="sendPopup-close" @click="zenpingxiangqin=false"></a>
      </div>
    </div>
      <div id="divSelectCourseMask" v-show="show" tabindex="0" style="position: fixed; left: 0px; top: 0px; width: 100%; height: 100%; overflow: hidden; user-select: none; z-index: 9999; background: rgb(0, 0, 0); opacity: 0.7;" class="ui-popup-backdrop"></div>
            <table class="ui-dialog-grid1" :style="'margin-top:'+(200)+'px;margin-left:-'+(420)+'px'" v-show="show"> 
                <tbody>
                    <tr>
                        <td class="ui-dialog-header">
                            <button i="close" class="ui-dialog-close" @click="close()" title="cancel">×</button>
                            <div i="title" class="ui-dialog-title">{{this.baoMinName}}</div>
                        </td>
                    </tr>
                    <tr>
                        <td class="ui-dialog-body" style="padding: 0px;">
                            <div class="ui-dialog-content">
                                <div class="cmb_box bm-ke" style="padding: 10px 20px 20px;">
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>点击选课</th>
                                        <th width="48%">新版课程</th>
                                        <th>讲师</th>
                                        <th>讲数</th>
                                        <th>价格</th>
                                        <th v-if="showTitle">活动价</th>
                                        <th>免费体验</th>
                                      </tr>
                                    </thead>
                                  <tbody class="wx-popup4-list">
                                    <tr  @click="check(v.MyClassId)"  :class="checkList.indexOf(v.MyClassId)>-1?'checked':''" v-for="(v,i) in baoMinList" :key="i">
                                      <td>
                                        <span class="gou"></span>
                                      </td>
                                      <td class="text-c">{{v.MyClassName.replace("取证","VIP").replace("取证VIP","VIP")}}</td>
                                      <td>{{v.Teacher}}</td>
                                      <td>{{v.CourseNum}}讲</td>
                                      <td>¥{{v.GoodPrice}}</td>
                                      <td class="price" v-if="v.SpecialPrice>0">
                                        <font color="#e45433">{{v.SpecialPrice>0?"¥"+v.SpecialPrice:"暂无优惠"}}</font>
                                      </td>
                                      <td><a class="listen" target="_blank" :href="'/course/study/?mid='+v.MyClassId">免费试听</a></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                                <div class="cmb_t3 clearfix">
                                    <p class="cmb2_bottom_p">
                                      <span class="cmb2_bottom_span js-popup5-msg"></span>
                                      <a @click="baomin()" href="javascript:;" class="ljbm_btn js-popup5-bm">立即报名</a>
                                    </p>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td i="footer" class="ui-dialog-footer" style="display: no ne;">
                            <div i="statusbar" class="ui-dialog-statusbar" style="display: no ne;"></div>
                            <div i="button" class="ui-dialog-button"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
      <div class="main-title f-tac p-30-0  bg-white " >
        <p class="font-bg">STUDY</p>
        <h2 class="font44 fb">{{calssName}}<em class="text-red fb">班级对比</em></h2>
        <p class="font17 text-gry-6 lh2">千挑万选好导师，千锤百炼精课程</p>
      </div>
      <div :class="list.length==2?'course-wrap':(list.length==3?'course-wrap  class-box-three':'course-wrap  class-box-four')" ><!--三栏样式请在此处添加 class-box-three--> 
        <div class="course-inner-headbox" v-if="this.classEName=='teacher'"> 
          <!--科目-->
          <div class="course-inner-head " >
            <div class="head-area  text-gry6 font14 fl"  style="display: none;"> 当前地区
              <p class="m-l-15  bg-white fr m-t-20"><em class="now-area p-0-20">全国版</em><a href="" class="more-area p-0-10">更多地区 </a></p>
            </div>
            <div class="area_list" style="display: none;">
              <ul>
                <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                <li><a href="/tegang/henan/">河南</a></li>
                <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
              </ul>
            </div>
            <!--选地区-end-->
            
            <div class="head-subject f-tal font20 fb"> 
              <!--无专业区分 --> 
            <!-- <div class="subject-title font28" >教师资格</div>  -->
              
              <!--有专业区分-->
              <div class="subject-title" >
                <a href="javascript:" :class="xueIndex==0?'now-subject bg-sblue':''" @click="changeXueIndex(0)">中学</a>
                <a href="javascript:" :class="xueIndex==1?'now-subject bg-sblue':''" @click="changeXueIndex(1)">小学</a>
                <a href="javascript:" :class="xueIndex==2?'now-subject bg-sblue':''" @click="changeXueIndex(2)">幼儿</a> 
              </div>
            </div>
            <!--专业-end-->
            
            <div class="head-active font16 "> 
              <!--活动剩余--> 
              <div class="active-box" v-if="data.ActivityTime">距活动结束剩余<em>{{day}}</em>天<em>{{hour}}</em>时<em>{{min}}</em>分<em>{{second}}</em>秒</div> 
              <!--考试剩余-->
              <div class="active-box" v-else-if="data.ExaminationTime">距{{dateStr}}考试剩余&nbsp;<em v-for="(v,i) in diffDays" :key="i">{{v}}</em>&nbsp;天</div>
            </div>
          </div>
        </div>
        <!--班级性质-->
        <div class="course-inner-headbox bg-white"  v-if="list.length>1" >
          <ul class="wx-class-header clearfix">
            <li class="wx-label-zhbj"></li>
            <li :class="i==0?'class-xz bg-sred':i==1?'class-xz bg-sblue':'class-xz bg-syellow'" v-for="(v,i) in list" :key="i"><span>{{v.BzCname.replace("取证","VIP").replace("取证VIP","VIP")}}</span></li>
          </ul>
        </div>
        <!--班级性质 end-->
        
        <div class="wx-class-box bg-white" v-if="list.length>1">
          <div class="wx-class-list font14">
            <table >
              <!--width="100%" border="0" cellspacing="0" cellpadding="0" style="table-layout:fixed;"-->
              <tbody>
                
                <!--适合学员-->
                <tr class="class-crowd">
                  <td class="wx-class-left bg-gry-f6">适合<br>
                    学员</td>
                  <td class="wx-class-right fb" v-for="(v,i) in list" :key="i"><p>{{v.Explain==null?'':v.Explain.replace("取证","VIP").replace("取证VIP","VIP")}}</p></td>
                </tr>
                <!--适合学员 end--> 
                
                <!--科目选择-->
                <tr class="class-subject">
                  <td class="wx-class-left bg-gry-f6">科目<br>选择</td>


                  <td class="wx-class-right"  v-for="(v,i) in list" :key="i">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                      <tbody>
                        <tr v-for="(vv,ii) in v.Details" :key="ii">
                        <!-- <tr> -->
                          <td class="class-name fb">{{vv.RowName==""?"全科":vv.RowName}}</td>
                          <td class="class-price  text-red fb" v-if="vv.SpecialPrice">
                            <span class="price-jiage dazhe font18 fb"> 
                              <i class="red-label"><i></i>活动价低至{{vv.SpecialPrice}}</i> 
                              <em> </em>
                              {{vv.Price}}
                            </span> 
                          </td>
                          <td class="class-price  text-red fb" v-else>{{vv.Price}}</td>
                          <td>
                            <a href="javascript:;" class="btn-redbg" @click="changeShow(i,ii)">报名试听</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </td>

                </tr>
                <!--科目选择 end--> 
                
                <!--包含班级-->
              <tr class="class-include">
                  <td class="wx-class-left bg-gry-f6">包含<br>班级</td>
                  <td class="wx-class-right " v-for="(v,i) in list" :key="i">
                    <p class="class-include-num">包含<i>{{v.ClassNum}}种</i>基础班级</p>
                    <div class="jieduan" v-if=" v.GettingStarted.length>0">
                      <p class="m-b-10 lh2 bg-qblue"><strong class="bg-sgreen">入</strong><b class="fb font16">门阶段</b> <b class="fr text-blue  p-r-10">快速入门，赢在起跑</b></p>
                      <span v-for="(vv,ii) in v.GettingStarted" :key="ii">{{vv}}</span>
                    </div>
                
                    <div class="jieduan" v-if=" v.Basis.length>0">
                      <p class="m-b-10 lh2 bg-qblue"><strong class="bg-blue">基</strong><b class="fb font16">础阶段</b> <b class="fr text-blue  p-r-10">全面讲解，夯实基础</b></p>
                        <span v-for="(vv,ii) in v.Basis" :key="ii">{{vv}}</span>
                    </div>
                
                    <div class="jieduan" v-if=" v.Strengthen.length>0">
                      <p class="m-b-10 lh2 bg-qblue"><strong  class="bg-sred">强</strong><b class="fb font16">化阶段</b> <b class="fr text-blue  p-r-10">强化考点，针对提分</b></p>
                      <span v-for="(vv,ii) in v.Strengthen" :key="ii">{{vv}}</span>
                    </div>
                
                    <div class="jieduan" v-if=" v.Sprint.length>0">
                      <p class="m-b-10 lh2 bg-qblue"><strong  class="bg-syellow ">冲</strong><b class="fb font16">刺阶段</b> <b class="fr text-blue  p-r-10">预测考试方向及趋势</b></p>
                      <span v-for="(vv,ii) in v.Sprint" :key="ii">{{vv}}</span>
                    </div>
                </td>
              </tr>
                <!--包含班级 end--> 
                
                <!--课程保障-->
                <tr class="class-characteristic">
                  <td class="wx-class-left bg-gry-f6 ">服务<br>保障</td>
                  <td class="wx-class-right " v-for="(v,i) in list" :key="i">
                    <ol>
                      <li>{{v.ExpirationDate}}</li>
                      <li v-if="ShowRelearn === 0">
                        <template v-if="v.Relearning>=10">
                            考试不过，可根据成绩单<span class="text-red">免费重学至通关</span>
                        </template>
                        <template v-else-if="v.Relearning<10&&v.Relearning>0">
                            考试不过，可根据成绩单<span class="text-red">免费重学{{v.Relearning}}次</span>
                        </template>
                        
                        <span v-else class="text-gry8a">无重学服务</span>
                      </li>
                    </ol>
                  </td>
                </tr>
                <!--课程保障 end--> 
                
                <!--赠送资料-->
                <tr class="class-feature">
                  <td class="wx-class-left bg-gry-f6">赠送<br>资料</td>
                  <td class="wx-class-right " v-for="(v,i) in list" :key="i">
                    <ol>
                      <li v-if="v.JiaoCai"><span class="song bg-red">送</span>官方正版教材（包邮）</li>
                      <li v-if="v.JiaoFu"><span class="song bg-red">送</span>老师精编教辅（包邮）</li>
                      <li v-if="v.TiKu"><span class="song bg-red">送</span>题库会员</li>
                      <li v-if="!v.JiaoCai&&!v.JiaoFu&&!v.TiKu">无</li>
                    </ol>
                    <div class="z-gift-xq" style="width:80px">
                      <a v-if="v.JiaoCai||v.JiaoFu||v.TiKu" @click="lookZpxq(v)" href="javascript:">查看<br><i>详情</i></a>
                    </div>
                  </td>
                </tr>
                <!--赠送资料 end-->
                
          <!--配套服务-->
                <tr class="class-feature">
                  <td class="wx-class-left bg-gry-f6">配套<br>服务</td>
                  <td class="wx-class-right "  v-for="(v,i) in list" :key="i">
                    <ol>
                      <li v-if="v.ZiLiao"><span class="song bg-red">享</span>考前资料</li>
                      <li><span class="song bg-red">享</span>助教答疑服务</li>
                    </ol>
                  </td>
                </tr>
                <!--配套服务 end-->  
            
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!--03原高级平台班级对比 end--> 
</template>
<script>
import { getClassComparison,getBook } from '@/request/request.js'
export default {
        name: 'App',
        props: {
            classEName:String,
            calssName:String,
        },
    components: {
      
    },
    data() {
        return {
          data:{},
          list:[],
          day: '0',
          hour: '00',
          min: '00',
          second: '00',
          dateStr:"",
          diffDays:[],
          show:false,
          baoMinList:[],
          baoMinName:"",
          xueIndex:0,
          myClassName:"",
          checkList:[],
          showTitle:false,
          zenpingxiangqin:false,
          zenpingClassList:[],
          zenpingxiangqinShowDetal:false,
          zenpingxiangqinDetailIndex:0,
          bookList:{},
          ShowRelearn: 1
        };
    },
    watch: {

    },
    mounted(){
      
    },
    created(){
      if(this.classEName=="teacher"){
        this.myClassName="中学";
        this.getClassComparison();
      }else{
        this.getClassComparison();
      }
    },
    methods:{
      changeZpClass(i,myClassId){
        getBook({myClassId:myClassId},(res)=>{
          this.bookList=res.Result;
        })
        this.zenpingxiangqinDetailIndex=i;
        this.zenpingxiangqinShowDetal=false;
      },
      lookZpxq(v){
        this.zenpingClassList.length=0;
         v.Details.forEach((item) => {
            item.Details.forEach(vv=>{
                this.zenpingClassList.push(vv);
            })
        })
        this.changeZpClass(0,this.zenpingClassList[0].MyClassId);
        this.zenpingxiangqin=true;
      },
      baomin(){
        if(this.checkList.length>0){
          var myclassids="";
          for(let i = 0,len=this.checkList.length; i < len; i++) {
            myclassids+=','+this.checkList[i];
          }
          window.location.href="/shopping?myclassid="+myclassids.substring(1);
        }
      },
      check(id){
        var list=this.checkList;
        var index=list.indexOf(id);
        if(index>-1){
          list.splice(index,1);
        }else{
          list.push(id);
        }
        this.checkList=list;
      },
      getClassComparison(){
        var cache=sessionStorage.getItem("banjiduibi"+this.classEName+this.myClassName);
        if(cache==undefined){
          getClassComparison({classEName:this.classEName,myClassName:this.myClassName},(res)=>{
            this.data=res.Result;
            this.list=this.data.List;
            this.ShowRelearn = this.data.ShowRelearn
            if(this.data.ActivityTime){
              this.countTime(this.data.ActivityTime);
            }else if(this.data.ExaminationTime){
              var date= this.data.ExaminationTime.split(" ")[0].split("-");
              this.dateStr=date[0]+"年"+date[1]+"月"+date[2]+"日";
              this.diffDays= this.DateDiff(this.data.ExaminationTime,this.dateFormat(new Date(),"yyyy-MM-dd HH:mm:ss")).toString().split("");
            }
            sessionStorage.setItem("banjiduibi"+this.classEName+this.myClassName,JSON.stringify(res.Result));
          });
        }else{
          this.data=JSON.parse(cache);
            this.list=this.data.List;
            this.ShowRelearn = this.data.ShowRelearn
            if(this.data.ActivityTime){
              this.countTime(this.data.ActivityTime);
            }else if(this.data.ExaminationTime){
              var date= this.data.ExaminationTime.split(" ")[0].split("-");
              this.dateStr=date[0]+"年"+date[1]+"月"+date[2]+"日";
              this.diffDays= this.DateDiff(this.data.ExaminationTime,this.dateFormat(new Date(),"yyyy-MM-dd HH:mm:ss")).toString().split("");
            }
        }
      },
      changeXueIndex(i){
        this.xueIndex=i;
        this.myClassName=i==0?"中学":i==1?"小学":"幼儿";
        this.getClassComparison();
      },
      close(){
        this.show=false;
      },
      changeShow(i,ii){
        this.show=true;
        this.baoMinList=this.list[i].Details[ii].Details;
        this.baoMinList.forEach(item => {
          if(item.SpecialPrice>0){
            this.showTitle=true;
          }else{
            this.showTitle=false;
          }
        });
        this.baoMinName=this.list[i].BzCname;
      },
        countTime (time) {
          // 获取当前时间
            let date = new Date()
            let now = date.getTime()
            let endDate = new Date(time) // this.curStartTime需要倒计时的日期
            let end = endDate.getTime()
            let leftTime = end - now
            if (leftTime >= 0) {
              this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
              let h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
              this.hour = h < 10 ? '0' + h : h
              let m = Math.floor(leftTime / 1000 / 60 % 60)
              this.min = m < 10 ? '0' + m : m
              let s = Math.floor(leftTime / 1000 % 60)
              this.second = s < 10 ? '0' + s : s
            } else {
              this.day = 0
              this.hour = '00'
              this.min = '00'
              this.second = '00'
            }
            if (Number(this.hour) === 0 && Number(this.day) === 0 && Number(this.min) === 0 && Number(this.second) === 0) {
              return
            } else {
              setTimeout(this.countTime, 1000)
            }
         },
         DateDiff(sDate1,sDate2){
           var aDate,oDate1,oDate2,iDays;
           aDate=sDate1.split(" ")[0].split("-");
           oDate1=new Date(aDate[0],aDate[1],aDate[2]);
           aDate=sDate2.split(" ")[0].split("-");
           oDate2=new Date(aDate[0],aDate[1],aDate[2]);
           iDays=parseInt(Math.abs(oDate1-oDate2)/1000/60/60/24);
           return iDays;
         },
         dateFormat(date,fmt) {
            let ret;
            const opt = {
                "y+": date.getFullYear().toString(),        // 年
                "M+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "m+": date.getMinutes().toString(),         // 分
                "s+": date.getSeconds().toString()          // 秒
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        }
    },
}
</script>
<style scoped>
  .center {
    border-radius: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 99999999
  }
</style>